import { render, staticRenderFns } from "./task-form.vue?vue&type=template&id=fc5808b2&scoped=true"
import script from "./task-form.vue?vue&type=script&lang=js"
export * from "./task-form.vue?vue&type=script&lang=js"
import style0 from "./task-form.vue?vue&type=style&index=0&id=fc5808b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5808b2",
  null
  
)

export default component.exports